import { Star } from "lucide-react"

// Single relevance metaphor across the app: 5 stars + numeric score. Previously the list
// pages showed stars while NewsPostsModal showed a "%" badge for the same 0-100 value,
// and a score of 0 rendered as blank space under its label.
export function RelevanceScore({ score }: { score: number | null | undefined }) {
  if (score == null) {
    return <span className="text-xs text-muted-foreground">Kein Score</span>
  }
  const stars = Math.round(score / 20)
  return (
    <div className="flex items-center gap-1" data-testid={`relevance-score-${score}`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className={`w-4 h-4 ${i < stars ? "fill-yellow-400 text-yellow-400" : "text-gray-300 dark:text-gray-600"}`}
        />
      ))}
      <span className="text-xs text-muted-foreground ml-1">({score}/100)</span>
    </div>
  )
}
